<ng-container *ngIf="headerText && !hideBreadcrumbs">
    <ng-container *transloco="let t">
        <div
            class="flex items-center justify-start border px-3 py-3"
            [ngClass]="{ 'bg-card': bg === 'white', 'bg-default': !bg || bg !== 'white', 'absolute -my-100 opacity-0': hidden }">
            <button
                mat-icon-button
                class="-ml-1 mr-2"
                [matTooltip]="'general.toggle_navigation' | transloco"
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>

            <div class="min-w-0">
                <nav class="mr-6 text-sm">
                    <ol class="list-reset flex text-gray-700">
                        <li *ngFor="let breadcrumb of isScreenAtLeast('md') ? breadcrumbs : breadcrumbs.slice(-2); let last = last">
                            <ng-container *ngIf="!last">
                                <a
                                    [routerLink]="breadcrumb.url"
                                    [queryParams]="breadcrumb.queryParams"
                                    class="text-primary hover:underline">
                                    {{ !isScreenAtLeast('md') ? '...' : (breadcrumb.label | transloco: breadcrumb.translationParams) }}
                                </a>
                                <span class="mx-2">/</span>
                            </ng-container>
                            <ng-container *ngIf="last">
                                <span>{{ breadcrumb.label | transloco: breadcrumb.translationParams }}</span>
                            </ng-container>
                        </li>
                    </ol>
                </nav>
            </div>

            <!-- Ricerca globale dei PO, raggiungibile da qualsiasi pagina -->
            <app-global-search class="hidden shrink-0 sm:block"></app-global-search>
            <div class="ml-auto flex items-center gap-3">
                <!-- Sezione per il contenuto iniettato -->
                <div *ngIf="headerContentTemplate">
                    <ng-container [ngTemplateOutlet]="headerContentTemplate"></ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
